import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectApprovalAnalyticIds = {
  projectOwnerId: string;
  clearProjectOwnerBtnId: string;
  commentId: string;
  approveBtnId: string;
  resetBtnId: string;
};

export const useAscProjectApprovalAnalyticIds = (): AscProjectApprovalAnalyticIds => ({
  projectOwnerId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_PROJECT_OWNER),
  clearProjectOwnerBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_PROJECT_OWNER_CLEAR_BUTTON),
  commentId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_COMMENT),
  approveBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_APPROVE_BUTTON),
  resetBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_RESET_BUTTON),
});
